import BillingRunStatistic from "@/modules/billingRunStatistic/view/BillingRunStatistic.vue";

export const BillingOverviewRoutes = [
    {
        path: '/billing/run/statistic',
        component: BillingRunStatistic,
    }
]